export const ApiEndpoints = {
  transitionJHAnalysis: 'Job-Hazard-Analysis',
  getSafetyEventStateMachine: 'safety-event/state-machine',
  transitionSafetyEvent: 'safety-event',
  getComplianceEventStateMachine: 'compliance-event/state-machine',
  transitionComplianceEvent: 'compliance-event',
  getItemAssignmentStateMachine: 'item-assignment/state-machine',
  transitionItemAssignment: 'item-assignment',

  vendorImport: 'Vendor/import',
  vendorImportTemplate: 'Vendor/import/template',

  getPersonnel: 'Personnel/list',
  getDeparments: 'Department/list',
  uploadFile: 'File',
  uploadPresigned: 'File/UploadPreSignedFile/presign-url/create',
  getItemsList: 'Instance/list',
  getTasksList: 'Task/list',
  getAssignmentsList: 'Task/assigned/list',
  getPersonnelList: 'Personnel/list',
  getComplianceList: 'Compliance/list',
  personnelImport: 'Personnel/import',
  personnelImportTemplate: 'Personnel/import/template',
  personnelImportColumns: 'Personnel/import/columns',
  personnelImportPreview: 'Personnel/import/preview',
  createItem: 'Item',
  createInstance: 'Instance',
  createTask: 'task',
  updateItem: 'Item',
  updateTask: 'Task',
  updatePerson: 'Personnel',
  updateActiveInstance: 'User/instance',
  updateInstance: 'Instance',
  getAssetTypeList: 'AssetType/list',
  getAssetTypeListNavigation: 'AssetType/list/navigation',
  getAssetType: 'AssetType',
  createAssetType: 'AssetType',
  updateAssetType: 'AssetType',
  getAssetList: 'Asset/list',
  getAsset: 'Asset',
  createAsset: 'Asset',
  updateAsset: 'Asset',
  getItem: 'Item',
  getTask: 'Task',
  getPerson: 'Personnel',
  getAssigneesList: 'Task',
  batchStatusUpdate: 'Item/PostBatchStatusUpdate', // question this endpoint
  createStaticForm: 'Form',
  getStaticFormList: 'FormDefinition/list',
  getFormList: 'Form/list',
  formDefinition: 'FormDefinition',
  getStaticForm: 'Form',
  getOpenItems: 'Task/reporting/open',
  getExportAttendance: 'ItemReport/ExportAttendanceReport',
  getUserInstances: 'User/instance/list',
  getInstanceList: 'Instance/List',
  getInstanceDetail: 'Instance',
  getCheckAuthentication: 'Instance/auth-type',
  form: 'form',
  createRiskAssessmentCode: 'Risk-Assessment-Code',
  getRiskAssessmentCode: 'Risk-Assessment-Code',
  getRiskAssessmentCodeByArea: 'Risk-Assessment-Code/area',
  getRiskAssessmentCodeList: 'Risk-Assessment-Code/list',
  updateRiskAssessmentCode: 'Risk-Assessment-Code',
  deleteRiskAssessmentCode: 'Risk-Assessment-Code',
  getUserClaims: 'User/claims',
  createJHAnalysis: 'Job-Hazard-Analysis',
  getJHAnalysis: 'Job-Hazard-Analysis',
  getJHAnalysisList: 'Job-Hazard-Analysis/list',
  updateJHAnalysis: 'Job-Hazard-Analysis',
  deleteJHAnalysis: 'Job-Hazard-Analysis',
  getTaskDefinitionStateMachine: 'task-definition/state-machine',
  getTaskAssignmentStateMachine: 'task-assignment/state-machine',
  getCourseClassroomStateMachine: 'course-classroom/state-machine',
  getSafetyEventFieldValues: 'safety-event/field-values',
  exportSafetyEvent: 'safety-event/export',
  getSafetyEventCounts: 'safety-event/counts',
  getDepartmentTaskParticipation:
    'reporting/task/department-task-participation',
  getComplianceStandardList: 'compliance-standard/list',
  getComplianceStandard: 'compliance-standard',
  getCustomComplianceStandardList: 'compliance-standard/custom/list',
  getCustomComplianceStandard: 'compliance-standard/custom',
  customStandardImport: 'compliance-standard/custom/import',
  customStandardImportTemplate: 'compliance-standard/custom/import/template',
  getInstanceComplianceStandard: 'instance-compliance-standard',
  getInstanceComplianceStandardsList: 'instance-compliance-standard/list',
  getComplianceFindingsList: 'reporting/compliance/findings',
  getComplianceFindingsDetailList: 'reporting/compliance/findings/detail',
  getComplianceCommunicationList: 'reporting/compliance/communication',
  getComplianceCommunicationDetailList:
    'reporting/compliance/communication/detail',
  getCompliancePlanList: 'reporting/compliance/plan',
  getCompliancePlanDetailList: 'reporting/compliance/plan/detail',
  getVendors: 'vendor/list',
  assetTypeImportTemplate: 'AssetType/import/template',
  assetTypeImport: 'AssetType/import',
  assetTypeExport: 'AssetType/export',
  assetImportTemplate: 'Asset/import/template',
  assetImport: 'Asset/import',
  assetExport: 'Asset/export',
  deviceImportTemplate: 'device/import/template',
  deviceImport: 'device/import',
  equipmentTypeImportTemplate: 'equipment-type/import/template',
  equipmentTypeImport: 'equipment-type/import',
};
